/** Shared by Strategy Details (calendar) and Results dashboard (summary metrics). */

export const DAY_ORDER = ['Mon', 'Tue', 'Wed', 'Thu', 'Fri'];

/**
 * Red-folder (USD high-impact news) markers and filters on Results and the
 * Portfolio Simulator. Turned off for now; set to true to bring them back.
 * While off, saved red-folder filter choices are ignored.
 */
export const RED_FOLDER_FILTER_ENABLED = false;

export const DEFAULT_DISPLAY_FILTER = {
  days: { Mon: true, Tue: true, Wed: true, Thu: true, Fri: true },
  redFolderOnly: false,
  nonRedFolderOnly: false,
  rolloverOnly: false,
  nonRolloverOnly: false,
};

export function isDisplayFilterActive(f) {
  if (!f) return false;
  if (RED_FOLDER_FILTER_ENABLED && (f.redFolderOnly || f.nonRedFolderOnly)) return true;
  if (f.rolloverOnly || f.nonRolloverOnly) return true;
  return DAY_ORDER.some((d) => !f.days[d]);
}

/**
 * rollCtx: { rollFilterEnabled: boolean, inRollWeek: boolean } — only MNQ/NQ roll applies
 */
export function dayPassesDisplayFilter(dateKey, dayOfWeekShort, filter, highImpactEventsByDate, rollCtx) {
  if (!filter) return true;
  if (!filter.days[dayOfWeekShort]) return false;
  if (RED_FOLDER_FILTER_ENABLED && filter.redFolderOnly && !highImpactEventsByDate?.has(dateKey)) return false;
  if (RED_FOLDER_FILTER_ENABLED && filter.nonRedFolderOnly && highImpactEventsByDate?.has(dateKey)) return false;
  if (rollCtx?.rollFilterEnabled) {
    if (filter.rolloverOnly && !rollCtx.inRollWeek) return false;
    if (filter.nonRolloverOnly && rollCtx.inRollWeek) return false;
  }
  return true;
}

/**
 * Distinct YYYY-MM keys for all Mon–Fri calendar days in strategy sheet rows (for loading high-impact data).
 * @param {Array} rows Raw sheet rows (header rows + data)
 * @returns {string[]}
 */
export function uniqueMonthKeysFromStrategyRows(rows) {
  if (!rows || rows.length < 3) return [];
  const months = new Set();
  const dataRows = rows.slice(2);
  dataRows.forEach((row) => {
    const date = row[0];
    const parts = (date || '').split('.');
    if (parts.length !== 3) return;
    const mm = parseInt(parts[0], 10);
    const dd = parseInt(parts[1], 10);
    const yyyy = parseInt(parts[2], 10);
    if (isNaN(mm) || isNaN(dd) || isNaN(yyyy)) return;
    for (let i = 0; i < 5; i += 1) {
      const d = new Date(yyyy, mm - 1, dd + i);
      months.add(`${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}`);
    }
  });
  return Array.from(months).sort();
}
